import { combineReducers } from 'redux';

import {
  CONFIRM_EMPLOYEE_INVALID_INVITATION,
  CONFIRM_EMPLOYEE_SET_INVITED_EMPLOYEE,
} from '../../actions/confirmEmployee/constants';
import createReducer from '../../utils/createReducer';

const invalidInvitation = createReducer(false, {
  [CONFIRM_EMPLOYEE_INVALID_INVITATION]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.invalidInvitation,
});

const business = createReducer(null, {
  [CONFIRM_EMPLOYEE_SET_INVITED_EMPLOYEE]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.invitedEmployee.business,
});

// TODO doesn't seem to be used anywhere
const employee = createReducer(null, {
  [CONFIRM_EMPLOYEE_SET_INVITED_EMPLOYEE]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.invitedEmployee.employee,
});

const invitedEmployee = combineReducers({
  business,
  employee,
});

export default combineReducers({
  invalidInvitation,
  invitedEmployee,
});
